type Translation = {
  [key: string]: string;
};

const de: Translation = {
  'scan.pin': 'Scan-PIN',
  'scan.pin.enter': 'Scan-PIN eintragen',
  'scan.pin.info':
    'Der Scan-PIN ist ein 6-stelliger Code, der dir von den Organisator:innen der Veranstaltung zur Verfügung gestellt wird',
  'scan.module.select': 'Scan-Modul Auswahl',
  'scan.module.none':
    'Es wurden noch keine Scan-Module für dieses Event erstellt',
  'scan.module.go': 'Zum Scan-Modul',
  'scan.delegate.number': 'Delegiertennummer',
  'scan.success': 'Erfolgreich gescannt!',
  'scan.failed': 'Scan fehlgeschlagen',
  'scan.error': 'Ein Fehler ist aufgetreten',
  'scan.retry': 'Erneut scannen',
  'scan.success.message':
    '{dval1} ({dval2}) heute um {dval3} zum {dval4}. mal erfolgreich erfasst',
  'scan.nomination.inactive': '{dval1} ({dval2}) nicht berechtigt',
  'scan.error.invalid.pin': 'Ungültiger Scan-PIN',
  'scan.error.session.expired': 'Sitzung abgelaufen',
  'scan.error.unauthorized': 'Nicht autorisiert',
  'scan.error.invalid.delegate': '{dval1} ist keine gültige Delegiertennummer',
  'scan.error.forbidden': 'Zugriff verweigert',
  'scan.error.generic': 'Ein Fehler ist aufgetreten',
  'scan.checkin': 'Check-In',
  'scan.checkout': 'Check-Out',
  'scan.checkin.success.message':
    '{dval1} ({dval2}) wurde um {dval3} erfolgreich eingecheckt',
  'scan.checkout.success.message':
    '{dval1} ({dval2}) wurde um {dval3} erfolgreich ausgecheckt',
  'scan.error.SCAN_LIMIT_REACHED':
    '{dval1} ({dval2}) hat die maximale Anzahl an Scans ({dval3}) bereits erreicht',
  'scan.error.ALREADY_CHECKED_IN': '{dval1} ({dval2}) ist bereits eingecheckt',
  'scan.error.ALREADY_CHECKED_OUT': '{dval1} ({dval2}) ist bereits ausgecheckt',
};

export default de;
